import DonutChartWidget from './donut-chart.widget';
export default DonutChartWidget;
